import { render } from "./footer.vue?vue&type=template&id=38de7bb5&scoped=true&ts=true"
import script from "./footer.vue?vue&type=script&lang=ts"
export * from "./footer.vue?vue&type=script&lang=ts"

import "./footer.vue?vue&type=style&index=0&id=38de7bb5&scoped=true&lang=sass"

import exportComponent from "/drone/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-38de7bb5"]])

export default __exports__